if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.buy_button_group = this.querySelector('.buy-buttons-group');
        this.buy_button = this.querySelector('.buy-buttons');
        this.notify_button = this.querySelector('.notify-btn');
        this.quantityInput = this.querySelector('.quantity__input');
        this.currentVariant = this.getAttribute('data-variant-id');
        this.currentproductUrl = this.getAttribute("data-url");
        this.allVariants = this.querySelector('[data-all-variants]') ? JSON.parse(this.querySelector('[data-all-variants]').innerHTML) : [];
        this.selectedVariant = this.querySelector('[data-selected-variant]') ? JSON.parse(this.querySelector('[data-selected-variant]').innerHTML) : '';
        this.deselectSizeFlag = this.getAttribute('data-deselect-size') === 'true' || false;  // Deselect size flag
        this.deselectSizeBtnDoor = this.querySelector('.deselect_size_choosetip_btn_door');  // Tips button cover above ATC button
        this.colorBackground = this.querySelector('.swatch-container.color-swatch input[type=radio]:checked')?.parentElement?.querySelector('.swatch')?.getAttribute('color') || '';  // 初始化 默认选中color option
        this.otherOptionBox = this.querySelectorAll('.other-option-box'); // 除Color / Size外，作为option1、option2的option
        this.sizeOptionIndex = parseInt(this.querySelector('.size-swatch')?.getAttribute('data-option-index'));
        this.whatIncludedBox = this.querySelector('#panel-include');
        this.whatIncludedObj = window.includedHtmlSnippet || {};
        this.currentBatteryHandle = this.querySelector('.battery-swatch input:checked')?.getAttribute('data-option-handle') || '';
        this.lengthOption = this.querySelector('.length-swatch'); // Length Option
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        this.initSelectVariant(this.currentVariant);
        this.initSwatchWidth();
        this.initLengthOption();
        this.handleIncludedContent(true);
        this.handleSaveOff(this.getSelectedVariant(this));
      }
      initSelectVariant(currentVariant){
        // if(currentVariant) 
        // this.updateURL(this.currentproductUrl, currentVariant);

        // Custom Code: 初始化(链接带variant参数)默认选中有效变体
        if(currentVariant && this.selectedVariant && !this.selectedVariant.available) {
          let target = this.querySelector('variant-selects input[data-option-value-id]');
          let variantSelects = this.querySelector('variant-selects');
          let availableVariantsByOptions = this.allVariants?.filter(variant => variant.title !== this.selectedVariant.title && variant.available);
          let selectedOptionValues = Array.from(this.querySelectorAll('select option[selected], fieldset:not(.add_collection_swatch) input:checked')).map(({ dataset }) => dataset.optionValueId);
          this.handleAvailableVariant(target, variantSelects, selectedOptionValues, availableVariantsByOptions);
          target = this.querySelector(`variant-selects input[data-option-value-id="${selectedOptionValues[0]}"]`);
          this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(this.currentproductUrl, selectedOptionValues, false),
            targetId: target?.id,
            callback: this.handleUpdateProductInfo(this.currentproductUrl, target, selectedOptionValues)
          });
        } else if (currentVariant){
          this.updateURL(this.currentproductUrl, currentVariant);
        }
      }
      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues, selectedVariantTitle } }) {
        if (!this.contains(event.target)) return;

        // Custom Code: disabled add to cart button when change variant
        this.productForm?.querySelector('.product-form__submit')?.classList.add('not-allowed');

        // Custom Code: Deselect size - 未选择Size，返回的selectedOptionValues数组长度不等于fieldset数量，需要将第一个有效的Size值整合到selectedOptionValues数组
        if(this.deselectSizeFlag) {
          if(selectedOptionValues.length !== this.querySelectorAll('fieldset:not(.add_collection_swatch)').length) {
            selectedOptionValues = [];
            this.querySelectorAll('fieldset:not(.add_collection_swatch)')?.forEach((item) => {
              if(item.querySelector('input:checked')) {
                selectedOptionValues.push(item.querySelector('input:checked').dataset.optionValueId);
              } else {
                selectedOptionValues.push(item.querySelector('input:not(.disabled)')?.dataset.optionValueId || item.querySelector('input').dataset.optionValueId);
              }
            });
            this.deselectSizeBtnDoor.style.display = 'block';
          } else {
            this.deselectSizeBtnDoor.style.display = 'none';
            window.chooseTipsActive = false;
          }
        }

        // Custom Code: 如果待切换的变体无库存，则通过修改target和selectedOptionValues来实现选中有库存变体
        if(!this.allVariants?.find(variant => variant.title === selectedVariantTitle)?.available && !target.classList.contains('disabled')) {
          var availableVariantsByOptions = this.allVariants?.filter(variant => variant.title !== selectedVariantTitle && variant.available);
          this.handleAvailableVariant(target, target?.closest('variant-selects'), selectedOptionValues, availableVariantsByOptions);
        }
        
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl, target, selectedOptionValues),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        // productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html, target) {
        // const variantSelects = html.querySelector('variant-selects');

        // Custom code: if deselectSizeFlag && clicked target is not size swatch, remove checked on size swatch by default; if choose tips is active && clicked target is size swatch, show the choose tips by default
        if(this.deselectSizeFlag && !target?.closest('fieldset:not(.add_collection_swatch)')?.classList.contains('size-swatch')) {
          html.querySelector('variant-selects .size-swatch input:checked')?.removeAttribute('checked');
          if(window.chooseTipsActive) {html.querySelector('variant-selects .size-swatch')?.classList.add('choose-tips');}
          this.deselectSizeBtnDoor.style.display = 'block';
        }
        let variantSelects = html.querySelector('variant-selects');

        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
          this.initSwatchWidth();
          if (typeof window.applyEnglishColorSwatches === 'function') {
            window.applyEnglishColorSwatches(this);
          }
          this.handleIncludedContent();
        }
      }

      // Custom event: Determine if all length options are out of stock.
      initLengthOption() {
        if(this.lengthOption) {
          let notDisabledLengthArr = this.lengthOption.querySelectorAll('input:not(.disabled)');
          if(notDisabledLengthArr.length == 0) {
            this.lengthOption.classList.add('all-disabled');
          }
        }
      }
      // Custom event: set swatch(not color swatch) common width
      initSwatchWidth() {
        if(this.querySelectorAll(`.swatch-container:not(.color-swatch)`).length > 0){
          this.querySelectorAll(`.swatch-container:not(.color-swatch)`)?.forEach((el) => {
            let width = 0;
            let height = 0;
            if(el.querySelectorAll(`.swatch-label`).length > 1){
              el.querySelectorAll(`.swatch-label`).forEach((innerEl) => {
                if(width < innerEl.getBoundingClientRect().width){width = innerEl.getBoundingClientRect().width;}
                if(height < innerEl.getBoundingClientRect().height){height = innerEl.getBoundingClientRect().height;}
              });
              let maxW = Math.ceil(width + 2);
              let maxH = Math.ceil(height + 2);
              el.querySelectorAll(`.swatch-label`).forEach(innerEl => {innerEl.style.width = `${maxW}px`;innerEl.style.height = `${maxH}px`});
            }
          });
        }
      }
      // Custom code: change $xx OFF to card-badge and save_price
      handleSaveOff(variant) {
        if(variant) {
          let price = variant.price;
          let compare_at_price = variant.compare_at_price;
          if(this.querySelectorAll(`.slider-main-media .card__badge.on_sale`).length > 0){
            let card_badge_arr = this.querySelectorAll(`.slider-main-media .card__badge.on_sale`);
            let temp_price_off = Math.round((compare_at_price - price) / 100);
            if(temp_price_off != 0) {
              card_badge_arr.forEach(card_badge => {
                let card_badge_price = card_badge.querySelector(`.diff-price`);
                if(card_badge_price) {
                  card_badge.classList.remove('hidden');
                  card_badge_price.innerText = ` ${window.active_currency_symbol}${temp_price_off} `;
                }
              });
            } else {
              card_badge_arr.forEach(card_badge => {
                card_badge.classList.add('hidden');
              });
            }
          }
          if(this.querySelector(`.product-save-rate`) && this.querySelector(`.product-save-rate`)?.querySelector(`span`)){
            let save_rate = this.querySelector(`.product-save-rate`);
            let save_rate_price = this.querySelector(`.product-save-rate`)?.querySelector(`span`);
            let have_save_text = this.querySelector(`.product-save-text`);
            let temp_price_off = Math.round((compare_at_price - price) / 100);
            if(temp_price_off != 0) {
              save_rate.classList.remove('hidden');
              if(have_save_text) {
                save_rate_price.innerText = `${window.active_currency_symbol}${temp_price_off}`;
              }else {
                save_rate_price.innerText = `${window.active_currency_symbol}${temp_price_off}`;
              }
            } else {
              save_rate.classList.add('hidden');
            }
          }
        }
      }
      // Custom code: 如果初始化/待切换的变体无库存，则通过修改target和selectedOptionValues来实现选中有库存变体
      handleAvailableVariant(target, variantSelects, selectedOptionValues, availableVariantsByOptions) {
        let allSwatch = variantSelects?.querySelectorAll('.swatch-container');

        if(selectedOptionValues.length === 1) {
          // only one option
          target = variantSelects?.querySelector(`input[value='${availableVariantsByOptions[0]?.option1}']`);
          selectedOptionValues[0] = target?.getAttribute('data-option-value-id');
        } else if (selectedOptionValues.length === 2) {
          // two options
          let firstOptionArr = availableVariantsByOptions.filter(item => item.option1 === this.querySelector(`[data-option-value-id='${selectedOptionValues[0]}']`)?.value);
          let secondOptionArr = availableVariantsByOptions.filter(item => item.option2 === this.querySelector(`[data-option-value-id='${selectedOptionValues[1]}']`)?.value);
          if(firstOptionArr.length == 0) return;
          if(firstOptionArr.length > 0) {
            let secondOptionValue = firstOptionArr[0].option2;
            target = allSwatch[1]?.querySelector(`input[value='${secondOptionValue}']`);
            selectedOptionValues[1] = target.getAttribute('data-option-value-id');
          } else if (secondOptionArr.length > 0) {
            let firstOptionValue = secondOptionArr[0].option1;
            target = allSwatch[0]?.querySelector(`input[value='${firstOptionValue}']`);
            selectedOptionValues[0] = target.getAttribute('data-option-value-id');
          }
        } else if (selectedOptionValues.length === 3) {
          let firstOptionArr = availableVariantsByOptions.filter(item => item.option1 === this.querySelector(`[data-option-value-id='${selectedOptionValues[0]}']`)?.value);
          if(firstOptionArr.length == 0) return;
          // three options
          let firstAndThirdOptionArr = availableVariantsByOptions.filter(item => item.option1 === this.querySelector(`[data-option-value-id="${selectedOptionValues[0]}"]`)?.value && item.option3 === this.querySelector(`[data-option-value-id="${selectedOptionValues[2]}"]`)?.value);
          let firstAndSecondOptionArr = availableVariantsByOptions.filter(item => item.option1 === this.querySelector(`[data-option-value-id="${selectedOptionValues[0]}"]`)?.value && item.option2 === this.querySelector(`[data-option-value-id="${selectedOptionValues[1]}"]`)?.value);
          let secondAndThirdOptionArr = availableVariantsByOptions.filter(item => item.option2 === this.querySelector(`[data-option-value-id="${selectedOptionValues[1]}"]`)?.value && item.option3 === this.querySelector(`[data-option-value-id="${selectedOptionValues[2]}"]`)?.value);
          if(this.sizeOptionIndex == 1) {
            // 如果Option2是size，则优先判断当前option1&option3的组合是否存在有效变体，更改size的值
            if(firstAndThirdOptionArr.length > 0) {
              // 如果option1和option3组合存在有库存变体，则直接更改option2的值
              let secondOptionValue = firstAndThirdOptionArr[0].option2;
              target = allSwatch[1]?.querySelector(`input[value='${secondOptionValue}']`);
              selectedOptionValues[1] = target.getAttribute('data-option-value-id');
            } else if (firstAndSecondOptionArr.length > 0) {
              // 如果option1和option2组合存在有库存变体，则直接更改option3的值
              let thirdOptionValue = firstAndSecondOptionArr[0].option3;
              target = allSwatch[2]?.querySelector(`input[value='${thirdOptionValue}']`);
              selectedOptionValues[2] = target.getAttribute('data-option-value-id');
            } else if (secondAndThirdOptionArr.length > 0) {
              // 如果option2和option3组合存在有库存变体，则直接更改option1的值
              let firstOptionValue = secondAndThirdOptionArr[0].option1;
              target = allSwatch[0]?.querySelector(`input[value='${firstOptionValue}']`);
              selectedOptionValues[0] = target.getAttribute('data-option-value-id');
            }
          } else {
            if (firstAndSecondOptionArr.length > 0) {
              // 如果option1和option2组合存在有库存变体，则直接更改option3的值
              let thirdOptionValue = firstAndSecondOptionArr[0].option3;
              target = allSwatch[2]?.querySelector(`input[value='${thirdOptionValue}']`);
              selectedOptionValues[2] = target.getAttribute('data-option-value-id');
            } else if(firstAndThirdOptionArr.length > 0) {
              // 如果option1和option3组合存在有库存变体，则直接更改option2的值
              let secondOptionValue = firstAndThirdOptionArr[0].option2;
              target = allSwatch[1]?.querySelector(`input[value='${secondOptionValue}']`);
              selectedOptionValues[1] = target.getAttribute('data-option-value-id');
            } else if (secondAndThirdOptionArr.length > 0) {
              // 如果option2和option3组合存在有库存变体，则直接更改option1的值
              let firstOptionValue = secondAndThirdOptionArr[0].option1;
              target = allSwatch[0]?.querySelector(`input[value='${firstOptionValue}']`);
              selectedOptionValues[0] = target.getAttribute('data-option-value-id');
            }
          }
        }
      }
      // Custom code: Hide notify btn
      hideNotifyAndInventory(target) {
        let inventoryTips = this.querySelector('inventory-tips');
        if(this.deselectSizeFlag && !target?.closest('fieldset:not(.add_collection_swatch)')?.classList.contains('size-swatch')) {
          this.notify_button?.classList.add('hidden');
          inventoryTips?.classList.add('hidden');
        } else if (this.deselectSizeFlag && target?.closest('fieldset:not(.add_collection_swatch)')?.classList.contains('size-swatch')) {
          this.notify_button?.classList.remove('hidden');
          inventoryTips?.classList.remove('hidden');
        }
      }
      // Custom code: Handle color & size swatch in fixed price on mobile
      handleSwatchInFixedPrice(target) {
        // Handle color swatch
        let colorName = this.querySelector('.swatch-container.color-swatch input[type=radio]:checked')?.value;
        let colorBackground = this.querySelector('.swatch-container.color-swatch input[type=radio]:checked')?.parentElement?.querySelector('.swatch')?.getAttribute('color') || '';
        let fixedPriceSizeBox = this.querySelector('fixed-price .size-box');
        let sizeCondition = this.deselectSizeFlag && !target?.closest('fieldset:not(.add_collection_swatch)')?.classList.contains('size-swatch');
        let checkedSizeValue = this.querySelector('.swatch-container.size-swatch input[type=radio]:checked')?.value;
        let sizeValue = sizeCondition ? this.querySelector('fixed-price .size-box')?.getAttribute('data-option-name') : checkedSizeValue;
        let barLeftColorBox = this.querySelector('.bar-left-box [selected-color]');
        let barRightSizeBox = this.querySelector('.right-size-box [selected-size]');
        let sizeHtml = sizeCondition ? this.querySelector('.right-size-box')?.getAttribute('data-option-name') : checkedSizeValue;
        if(colorBackground && colorBackground != this.colorBackground) {
          this.colorBackground = colorBackground;
          // Mobile fixed price color box
          this.querySelector('fixed-price .color-box')?.style.setProperty('--fp-swatch-background', `url(${this.colorBackground})`);
          this.querySelector('fixed-price .color-box')?.style.setProperty('--fp-swatch-bg-color', colorName);
          // PC color box
          if(barLeftColorBox && colorName) {
            barLeftColorBox.innerText = colorName; 
          }
          this.querySelector('.bar-left-box .color-box')?.style.setProperty('--fp-swatch-background', `url(${this.colorBackground})`);
          this.querySelector('.bar-left-box .color-box')?.style.setProperty('--fp-swatch-bg-color', colorName);
        }
        // Handle size swatch
        if(fixedPriceSizeBox) {fixedPriceSizeBox.innerText = sizeValue;}
        if(barRightSizeBox) {barRightSizeBox.innerText = sizeHtml;}
        // Handle other swatch
        this.otherOptionBox?.forEach((item) => {
          let otherOptionIndex = item?.getAttribute('data-option-index');
          let otherOptionValue = this.querySelectorAll('.swatch-container') && this.querySelectorAll('.swatch-container')[otherOptionIndex].querySelector('input[type=radio]:checked')?.value;
          item.innerText = otherOptionValue;
        });
      }

      // Custom code: Handle what's included content according to battery
      handleIncludedContent(isInitial = false) {
        if (!this.whatIncludedBox) return;
        if (!this.whatIncludedObj || typeof this.whatIncludedObj !== 'object') return;
        // 获取当前选中的元素
        const checkedInput = this.querySelector('.battery-swatch input:checked');
        if (!checkedInput) return;
        // 获取数据句柄
        const currentBatteryHandle = checkedInput.getAttribute('data-option-handle');
        const newIncludedHtml = this.whatIncludedObj[currentBatteryHandle];
        // 如果新内容不存在，不进行更新
        if (!newIncludedHtml) return;
        // 判断是否需要更新
        const shouldUpdate = isInitial || currentBatteryHandle !== this.currentBatteryHandle;
        if (shouldUpdate) {
          this.currentBatteryHandle = currentBatteryHandle;
          this.whatIncludedBox.innerHTML = newIncludedHtml;
        }
      }

      handleUpdateProductInfo(productUrl, target, selectedOptionValues) { // Custom Code: target - changed option input
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html, target);
          this.updateURL(productUrl, variant?.id, target);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();

            // Custom code: if deselect size and size input change and variant no exist.
            if(!variant && this.deselectSizeFlag && target?.closest('fieldset:not(.add_collection_swatch)')?.classList.contains('size-swatch')) {
              this.querySelector(`[data-option-value-id="${target?.getAttribute('data-option-value-id')}"]`)?.setAttribute('checked', true);
            }
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          // Custom Code: Add pre order status
          if(variant.inventory_policy === 'continue' && variant.inventory_quantity === 0) {
            this.productForm?.toggleSubmitButton(false, window.variantStrings.preOrder);
          } else {
            this.productForm?.toggleSubmitButton(
              html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
              window.variantStrings.soldOut
            );
          }

          // Custom code: handle save off
          this.handleSaveOff(variant);
          // Custom code: hide klaviyo notify btn when variant change (deselect size)
          this.hideNotifyAndInventory(target);
          // Custom code: remove custom disabled attribute from add to cart button
          this.productForm?.querySelector('.product-form__submit')?.classList.remove('not-allowed');
          // Custom code: Handle color & size swatch in fixed price on mobile
          this.handleSwatchInFixedPrice(target);
          // Custom code: Handle length option
          this.initLengthOption();

          // Custom Code: Show notify-btn when option1 no available
          if(this.deselectSizeFlag && this.sizeOptionIndex && (html.querySelector('[data-option-index="0"] input:checked')?.classList?.contains('visually-disabled') || html.querySelector('[data-option-index="0"] input:checked')?.classList?.contains('disabled'))) {
            let notDisabledSizeArr =  html.querySelectorAll('.swatch-container.size-swatch input:not(.disabled)');
            let checkedSizeArr =  html.querySelectorAll('.swatch-container.size-swatch input:checked');
            let sizeSelectedId = selectedOptionValues[this.sizeOptionIndex];
            this.notify_button?.classList.remove('hidden');
            this.deselectSizeBtnDoor.style.display = 'none';
            window.chooseTipsActive = false;
            if(notDisabledSizeArr.length == 0 && checkedSizeArr.length == 0) {
              this.querySelector(`[data-option-index="${this.sizeOptionIndex}"] input[data-option-value-id="${sizeSelectedId}"]`)?.setAttribute('checked', 'checked');
            }
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });  
      }

      updateURL(url, variantId, target) { // Custom Code: target - changed option input
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false' || (this.deselectSizeFlag && !target?.closest('fieldset:not(.add_collection_swatch)')?.classList.contains('size-swatch'))) return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        // this.querySelector(`media-gallery`)?.setActiveMedia?.(
        //   `${this.dataset.section}-${variantFeaturedMediaId}`,
        //   true
        // );

        // Custom Code: not prepend featured media to media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(`${this.dataset.section}-${variantFeaturedMediaId}`, false);

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
